<nav
  class="navbar bg-primary text-white navbar-dark navbar-expand-lg d-none d-lg-flex shadow"
  [ngClass]="{
    'tt-navbar': isTicketTransfer
  }"
>
  <ng-container *notInPopulation="populations.TicketTransfer">
    <a
      class="navbar-brand py-0"
      [routerLink]="['/']"
      routerLinkActive="router-link-active"
      attr.aria-label="{{ 'nav.home.page.screenreader' | translate : { fgbdefault: 'Move to home page' } }}"
    >
      <label id="homeLink" class="accessibility-only">Go To Home Page</label>
      <img class="home-image" src="assets/images/rewards-logo.png" draggable="false" />
    </a>
  </ng-container>

  <ng-container *inPopulation="populations.TicketTransfer">
    <a
      class="navbar-brand py-0"
      [routerLink]="['/ticketTransfer']"
      routerLinkActive="router-link-active"
      attr.aria-label="{{ 'nav.home.page.screenreader' | translate : { fgbdefault: 'Move to home page' } }}"
    >
      <img alt="" class="ticket-transfer-club-logo" src="assets/images/logo.svg" draggable="false" />
    </a>
  </ng-container>

  <button
    class="navbar-toggler"
    type="button"
    (click)="isCollapsed = !isCollapsed"
    aria-controls="navbarSupportedContent"
    aria-expanded="false"
    attr.aria-label="{{ 'nav.toggle.screenreader' | translate }}"
  >
    <span class="navbar-toggler-icon"></span>
  </button>

  <!-- right Side Content -->
  <div class="right-side-container">
    <ng-container *notInPopulation="populations.TicketTransfer">
      <a class="club-site" href="{{ 'nav.club.site.url' | translate }}" target="_blank">
        {{ 'nav.club.site' | translate }}
      </a>
    </ng-container>
    <div
      class="navbar-collapse"
      [ngbCollapse]="isCollapsed"
      id="navbarSupportedContent"
      [ngClass]="{
        'tt-navbar-collapse': isTicketTransfer
      }"
    >
      <ng-container *notInPopulation="[populations.TicketTransfer]">
        <div class="nav-container">
          <ul class="navbar-nav" #greedyNav>
            <ng-container *notInPopulation="[populations.U18]">
              <li class="nav-item active">
                <a
                  class="nav-link mx-1"
                  [routerLink]="['/rewards']"
                  routerLinkActive="router-link-active"
                  attr.aria-label="{{ 'nav.rewards.screenreader' | translate : { fgbdefault: 'Move to rewards page' } }}"
                  >{{ 'nav.rewards' | translate }}</a
                >
              </li>
            </ng-container>
            <li class="nav-item active">
              <a
                class="nav-link mx-1"
                [routerLink]="['/challenges']"
                routerLinkActive="router-link-active"
                attr.aria-label="{{ 'nav.challenges.screenreader' | translate : { fgbdefault: 'Move to challenges page' } }}"
                >{{ 'nav.challenges' | translate }}</a
              >
            </li>
            <li class="nav-item active">
              <a
                class="nav-link mx-1"
                [routerLink]="['/games']"
                routerLinkActive="router-link-active"
                attr.aria-label="{{ 'nav.games.screenreader' | translate : { fgbdefault: 'Move to games page' } }}"
                >{{ 'nav.games' | translate }}</a
              >
            </li>

            <ng-container *fgbWebsiteContentFeatureFlag="'feature.flag.gallery'">
              <li class="nav-item active">
                <a
                  class="nav-link mx-1"
                  [routerLink]="['/gallery']"
                  routerLinkActive="router-link-active"
                  attr.aria-label="{{ 'nav.worksheet.screenreader' | translate : { fgbdefault: 'Move to Gallery page' } }}"
                  >{{ 'nav.gallery' | translate }}</a
                >
              </li>
            </ng-container>

            <ng-container *fgbWebsiteContentFeatureFlag="'feature.flag.offers'">
              <li class="nav-item active">
                <a
                  class="nav-link mx-1"
                  [routerLink]="['/offers']"
                  routerLinkActive="router-link-active"
                  attr.aria-label="{{ 'nav.offers.screenreader' | translate : { fgbdefault: 'Move to Offer page' } }}"
                  >{{ 'nav.offer' | translate }}</a
                >
              </li>
            </ng-container>

            <ng-container *notInPopulation="populations.U18">
              <li class="nav-item active">
                <a
                  class="nav-link mx-1"
                  [routerLink]="['/earn']"
                  routerLinkActive="router-link-active"
                  attr.aria-label="{{ 'nav.earn.screenreader' | translate : { fgbdefault: 'Move to earn page' } }}"
                  >{{ 'nav.earn' | translate }}</a
                >
              </li>
            </ng-container>

            <li ngbDropdown class="nav-item nav-help">
              <a type="button" class="nav-help-text nav-link" id="helpdropdownMenu" ngbDropdownToggle>
                {{ 'navbar.help' | translate }}
              </a>

              <div ngbDropdownMenu aria-labelledby="helpdropdownMenu" class="nav-help-links">
                <a ngbDropdownItem class="link" [routerLink]="['/faq']">{{ 'navbar.faq' | translate }}</a>
                <a ngbDropdownItem class="link" [routerLink]="['/contact']">{{ 'navbar.contact' | translate }}</a>
                <a ngbDropdownItem class="link" [routerLink]="['/terms']">{{ 'navbar.terms' | translate }}</a>
              </div>
            </li>
          </ul>
        </div>
      </ng-container>

      <ng-container *notInPopulation="populations.TicketTransfer">
        <!--New Dropdown (Needs Manage Tickets update before being looked at again)-->
        <div class="member me-2" ngbDropdown #ddAccount="ngbDropdown" [autoClose]="'outside'">
          <ng-container *notInPopulation="populations.U18">
            <div class="balance rounded font-size-14 text-white d-flex align-items-center" *ngIf="loyaltyPointsCard$">
              <span class="icon material-icons currency-icons pe-1" aria-hidden="true">emoji_events</span>
              <span class="ps-1 fw-bold">{{ loyaltyPointsCard$ | async | FortressCurrencyPipe : 'PTS' }}</span>
            </div>
          </ng-container>
          <!--Notifications-->
          <fgb-notification-button></fgb-notification-button>

          <button
            class="nav-link border-0 d-flex align-items-center mx-2 px-0 justify-content-end"
            id="namedropdown"
            ngbDropdownToggle
            attr.aria-label="{{
              'nav.account.dropdown.screenreader' | translate : { fgbdefault: 'Click for more account menu' }
            }}"
            tabindex="-1"
          >
            <div type="button" class="material-mobile-nav menu hamburger">
              <span></span>
              <span></span>
              <span></span>
            </div>
          </button>

          <div
            ngbDropdownMenu
            (click)="closeDropDown(ddAccount)"
            aria-labelledby="namedropdown"
            class="shadow text-center dropdown-menu border-0 account-dropdown"
          >
            <div class="mb-2">
              <a
                [routerLink]="['/account']"
                attr.aria-label="{{ 'nav.account.screenreader' | translate : { fgbdefault: 'Move to account page' } }}"
                class="d-flex align-items-center account-btn text-white py-0 px-2 nav-item-fixed-height rounded-top"
                ngbDropdownItem
              >
                <span class="icon material-icons material-dropdown-icon me-2" aria-hidden="true">person</span>

                <div class="dropdown-link text-start">
                  <div
                    *ngIf="memberDetails$ | async as memberDetails"
                    class="mt-2 mb-1 fw-bold font-size-14 nav-bar-popover-title-text font-heading"
                  >
                    {{ memberDetails!.FirstName }}
                    {{ memberDetails!.Surname }}
                  </div>
                  <div
                    class="nav-bar-little-text text-start"
                    *ngIf="{ card: card$ | async, memberDetail: memberDetails$ | async } as memberCard"
                  >
                    <span> {{ memberCard.card.ProductCode }} - {{ memberCard.memberDetail?.ExternalRefNumber }}</span>
                  </div>
                </div>
              </a>
            </div>
            <hr class="my-0 w-100" />
            <div class="my-2">
              <a
                [routerLink]="['/rewards/wallet']"
                routerLinkActive="router-link-active"
                attr.aria-label="{{ 'nav.wallet.screenreader' | translate : { fgbdefault: 'Move to wallet page' } }}"
                class="d-flex align-items-center account-btn text-white py-0 px-2 nav-item-fixed-height"
                ngbDropdownItem
              >
                <span class="icon material-icons material-dropdown-icon me-2" aria-hidden="true">account_balance_wallet</span>

                <div class="dropdown-link mt-1 text-start">
                  <div class="fw-bold nav-bar-popover-title-text mb-1 font-size-14">{{ 'nav.wallet' | translate }}</div>
                </div>
              </a>
            </div>
            <hr class="my-0 w-100" />
            <div class="my-2">
              <button
                class="logout-btn d-flex align-items-center text-secondary px-2 nav-item-fixed-height rounded-bottom"
                (click)="logout()"
                ngbDropdownItem
                attr.aria-label="{{ 'nav.log.out.screenreader' | translate : { fgbdefault: 'Log out' } }}"
              >
                <span class="icon material-icons material-dropdown-icon me-2 text-secondary" aria-hidden="true"
                  >power_settings_new</span
                >
                <div class="dropdown-link text-start">
                  <div class="text-secondary py-1 fw-bold font-size-14" ngbDropdownItem (click)="logout()">
                    {{ 'nav.log.out' | translate }}
                  </div>
                </div>
              </button>
            </div>
          </div>
        </div>
      </ng-container>
      <!--TT Dropdown-->
      <ng-container *inPopulation="populations.TicketTransfer">
        <div ngbDropdown class="nav-item nav-help me-4">
          <a type="button" class="nav-help-text nav-link tt-nav-dropdown" id="helpdropdownMenu" ngbDropdownToggle>
            <div *ngIf="memberDetails$ | async as memberDetails; else memberDetailsLoading" class="user-box h-100 d-inline-block">
              <div class="ticket-transfer-name font-size-12 font-default text-start fw-bold">{{ memberDetails!.FirstName }}</div>
            </div>
          </a>

          <div
            ngbDropdownMenu
            aria-labelledby="helpdropdownMenu"
            class="tt-dropdown-nav nav-help-links name-dropdown bg-tertiary"
          >
            <div>
              <button
                class="logout-btn d-flex align-items-center bg-tertiary px-2 nav-item-fixed-height rounded-bottom text-secondary p-2"
                (click)="logout()"
                ngbDropdownItem
                attr.aria-label="{{ 'nav.log.out.screenreader' | translate : { fgbdefault: 'Log out' } }}"
              >
                <span class="icon material-icons material-dropdown-icon me-2 text-secondary" aria-hidden="true"
                  >power_settings_new</span
                >
                <div class="dropdown-link text-start">
                  <div class="text-secondary py-1 font-size-12 fw-bold" ngbDropdownItem (click)="logout()">
                    {{ 'nav.log.out' | translate : { fgbdefault: 'Log out' } }}
                  </div>
                </div>
              </button>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</nav>
